/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_products = /** @type {(inputs: {}) => string} */ () => {
	return `Products`
};

/** @type {(inputs: {}) => string} */
const cs_products = en_products;

/** @type {(inputs: {}) => string} */
const da_products = en_products;

/** @type {(inputs: {}) => string} */
const de_products = en_products;

/** @type {(inputs: {}) => string} */
const es_products = en_products;

/** @type {(inputs: {}) => string} */
const fr_products = en_products;

/** @type {(inputs: {}) => string} */
const hu_products = en_products;

/** @type {(inputs: {}) => string} */
const it_products = en_products;

/** @type {(inputs: {}) => string} */
const nl_products = en_products;

/** @type {(inputs: {}) => string} */
const pl_products = en_products;

/** @type {(inputs: {}) => string} */
const pt_products = en_products;

/** @type {(inputs: {}) => string} */
const sv_products = en_products;

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const products = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.products(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("products", locale)
	if (locale === "cs") return cs_products(inputs)
	if (locale === "da") return da_products(inputs)
	if (locale === "de") return de_products(inputs)
	if (locale === "en") return en_products(inputs)
	if (locale === "es") return es_products(inputs)
	if (locale === "fr") return fr_products(inputs)
	if (locale === "hu") return hu_products(inputs)
	if (locale === "it") return it_products(inputs)
	if (locale === "nl") return nl_products(inputs)
	if (locale === "pl") return pl_products(inputs)
	if (locale === "pt") return pt_products(inputs)
	return sv_products(inputs)
};